function getEmojiReactionBubbleTextOffsetStyle() {
    return {transform: [{translateY: 0}]};
}

export default getEmojiReactionBubbleTextOffsetStyle;
